package ui.campaign.detailv2.editor.widget

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeOut
import androidx.compose.animation.shrinkVertically
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.mohamedrejeb.richeditor.ui.material3.RichText
import org.jetbrains.compose.resources.StringResource
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_top_detail_editor__info_action_read_more
import tools.rememberRichTextState
import tools.rememberString
import ui.campaign.detailv2.editor.CampaignEditorScope
import ui.campaign.detailv2.editor.NextButton


@Composable
fun CampaignEditorScope.ExplainUi(markdown: StringResource) {
    val state = rememberScrollState()
    var isExpanded by remember { mutableStateOf(false) }

    Column(
        Modifier.fillMaxSize()
            .padding(24.dp)
    ) {
        Column(Modifier.weight(1F).fillMaxWidth()) {
            RichText(
                state = rememberRichTextState(markdown),
                modifier = Modifier.width(800.dp)
                    .align(Alignment.CenterHorizontally)
                    .let {
                        if (isExpanded) it.wrapContentHeight(Alignment.Top)
                        else it.height(120.dp)
                    }
                    .verticalScroll(state),
                overflow = TextOverflow.Clip
            )
            Text("...", Modifier.align(Alignment.CenterHorizontally))
            AnimatedVisibility(
                !isExpanded,
                modifier = Modifier.align(Alignment.CenterHorizontally),
                exit = fadeOut() + shrinkVertically()
            ) {
                OutlinedButton(
                    onClick = { isExpanded = true },
                    enabled = !isExpanded
                ) {
                    Text(Res.string.layer_top_detail_editor__info_action_read_more.rememberString())
                }
            }
        }
        NextButton()
    }
}